<template>
	<div class="orderlist-items">
		<div class="cells">
			<div class="cell-image">Billede</div>
			<div class="cell-image">Product</div>
			<div class="cell-price">Pris (stk)</div>
			<div class="cell-quantity">antal</div>
			<div class="cell-total">total</div>
			<div class="cell-remove" v-if="type === 'cart'"/>
		</div>

		<div class="line"/>

		<div class="items">
			<item v-for="item in products" :key="item.id" v-bind="[item, {type}]"/>
		</div>
	</div>
</template>

<script>
import item from "./item/index.vue";

export default {
	components: {item},
	props: {
		products: {type: Array, required: true},
		type: {type: String, required: true}
	}
};
</script>

<style lang="scss" scoped>
.orderlist-items {
	border-bottom: 2px solid black;
	margin-bottom: 40px;
	padding-bottom: 1em;

	.cells {
		font-size: 10px;
		font-weight: 500;
		letter-spacing: 0.83px;
		text-transform: uppercase;
	}

	.line {
		width: 100%;
		border-bottom: 1px solid #272727;
	}

	/deep/ {
		.cells {
			width: 100%;
			display: flex;
			align-items: center;
			overflow: hidden;

			> div {
				padding: 16px;

				&:first-child {
					padding-left: 0;
				}
				&:last-child {
					padding-right: 0;
				}
			}

			.cell {
				&-image {
					width: 134px;
				}
				&-price {
					margin-left: auto;
					width: 200px;
				}
				&-quantity {
					width: 200px;
				}
				&-total {
					width: 200px;
					text-align: right;
				}
				&-remove {
					width: 30px;
					text-align: center;
				}
			}
		}
	}
}
</style>
